import classNames from "classnames";
import isEmpty from "lodash/isEmpty";
import Pill from "PFComponents/pill/pill";
import React from "react";
import { useTranslation } from "react-i18next";

import { ProfileRowErrors } from "../types";
import css from "../workforce.module.scss";

export const ErrorsHeader = ({ errors }: { errors: ProfileRowErrors }) => {
  const { t } = useTranslation("bookingModule");
  const hasErrors = !isEmpty(errors);

  return (
    <span className={classNames({ [css.errorText]: hasErrors })}>
      {t("config.calendars.workforce.errors")}{" "}
      {hasErrors && (
        <Pill className={css.errorPill} small>
          {Object.keys(errors).length}
        </Pill>
      )}
    </span>
  );
};
